import actionTypes, { baseURL } from "../actionTypes";
import axios from "axios";
// import filter from "lodash/filter";
import find from "lodash/find";
import { myCartList } from "./cart.action";

export const getBusinessNameFromUrl = () => {
  //api to fetch detail based on url
  // console.log('window url', window.location.href);
  // var url = 'https://hadiosers.optimizeapp.com';
  // var url = "https://nike.optimizeapp.com"
  // var url = 'https://testing.optimizeapp.com';
  // var url = 'https://uniquehypekw.optimizeapp.com';
  // var url = "https://alajmanalyoom.optimizeapp.com";
  // var url = 'https://finstyle.optimizeapp.com';
  // var url = 'https://atory.optimizeapp.com';
  // var url = 'https://willcafe.optimizeapp.com';
  // var url = 'https://apreskw.optimizeapp.com';
  // var url = 'https://jrkw.optimizeapp.com';
  // var url = 'https://bnorders.optimizeapp.com';
  // var url = 'https://lobsterlake.optimizeapp.com';
  // var url = 'https://nushin.optimizeapp.com';
  // var url = "https://marashkwt.optimizeapp.com/"
  // var url = "https://chocolateandkarak.optimizeapp.com/"
  var url = "https://testsk.optimizeapp.com/"
  // var url = "https://haykalah.optimizeapp.com/"
  // var url = "https://januaryeleven.optimizeapp.com/"
  // var url = "https://aljambamusic.optimizeapp.com/"
  // var url = "https://fashioniconq8.optimizeapp.com"
  // var url = "https://ikarusoud.optimizeapp.com/"
  // var url = "https://candle2020.optimizeapp.com/"
  // var url = "https://bonabeel.optimizeapp.com/"
  // var url = "https://standardgoodskw.optimizeapp.com/"
  // var url = "https://mamolq8.optimizeapp.com/"
  // var url = "https://nudekw.optimizeapp.com/"
  // var url = "https://shaheenmusic.optimizeapp.com/"
  // var url = "https://afashionillustrathion.optimizeapp.com/"
  // var url = "https://afashionillustrathion.optimizeapp.com/"
  // var url = "https://amaryllsperfumes.optimizeapp.com/"
  // var url = "https://abayatalghali.optimizeapp.com/"
  // var url = "https://withibrahim.optimizeapp.com/"
  // var url = "https://withibrahim.optimizeapp.com/"
  // var url = "https://withibrahim.optimizeapp.com/"
  // var url = "https://khairatuae.optimizeapp.com/"
  // var url = "https://alwidadperfume.optimizeapp.com"
  // var url = "https://lanaalkamaljewelry.optimizeapp.com"
  // var url = "https://manjaraty.optimizeapp.com/"
  // var url = "https://chaletfoursale.optimizeapp.com/"
  // var url = "https://isabellescenter.optimizeapp.com/"
  // var url = "https://myinvestment.optimizeapp.com/"




  // var pathname = new URL(window.location.href).host;
  var pathname = new URL(url).host;

  const businessName = pathname.split(".")[0];
  // console.log('businessName', businessName);
  return businessName
}

const getInstagramImages = async insta_handle => {
  try {
    var response = await axios.get(`https://www.instagram.com/${insta_handle}`);
    if (response && response.data) {
      var data = response.data;
      data = data.split("window._sharedData = ");
      data = data[1].split("</script>");
      data = data[0];
      data = data.substr(0, data.length - 1);
      data = JSON.parse(data);
      data =
        data.entry_data.ProfilePage[0] &&
        data.entry_data.ProfilePage[0].graphql.user;
      // console.log('data', JSON.stringify(data));
      // const mediaArray = [];

      const mediaList = data.edge_owner_to_timeline_media;

      let hasNextPage = mediaList.page_info.has_next_page;
      let end_cursor = mediaList.page_info.end_cursor;
      // console.log('mediaList', mediaList);
      // mediaArray.push(...mediaList.edges);
      // let hasNextPage = mediaList.page_info.has_next_page;
      // let end_cursor = mediaList.page_info.end_cursor;
      // To load all images at once
      // while (hasNextPage) {
      // 	console.log('hasNextPage', hasNextPage);

      // 	// (async () => {
      // 	const responseMedia = await axios.get(
      // 		`https://www.instagram.com/graphql/query/?query_id=17888483320059182&variables={"id":"${
      // 			data.id
      // 		}","first":${50},"after":"${end_cursor}"}`
      // 	);
      // 	console.log(
      // 		'responseMedia data',
      // 		responseMedia.data.data.user.edge_owner_to_timeline_media
      // 	);
      // 	mediaArray.push(...responseMedia.data.data.user.edge_owner_to_timeline_media.edges);
      // 	hasNextPage =
      // 		responseMedia.data.data.user.edge_owner_to_timeline_media.page_info.has_next_page;
      // 	end_cursor = responseMedia.data.data.user.edge_owner_to_timeline_media.page_info.end_cursor;
      // 	// }, 10000);
      // }
      // console.log('mediaArrayLength', mediaArray);

      if (mediaList.edges && mediaList.edges.length > 0) {
        var imagesList = mediaList.edges.map(media => {
          // console.log('media', media);

          return {
            imageUrl: media.node.display_url,
            shortcode: media.node.shortcode,
            imageId: media.node.id,
            // thumbnail: media.node.thumbnail_src,
            productDescription:
              media.node.edge_media_to_caption.edges.length > 0
                ? media.node.edge_media_to_caption.edges[0].node.text
                : "",
            isVideo: media.node.is_video
          };
        });
        // console.log('imageListBeforeSize', imagesList.length);

        // imagesList = filter(imagesList, media => {
        //   return !media.isVideo;
        // });

        return {
          imagesList,
          username: data.username,
          id: data.id,
          full_name: data.full_name,
          hasNextPage: hasNextPage,
          end_cursor: end_cursor
        };
        // console.log('imageListAfterSize', imagesList.length);
      }
      return {
        imagesList: [],
        username: data.username,
        id: data.id,
        full_name: data.full_name,
        hasNextPage: hasNextPage,
        end_cursor: end_cursor

      };
    }
  } catch (error) {
    console.log(
      "Error While retreivinggetInstagramImages ",
      error.response || error.message
    );
    return {
      imagesList: [],
      username: "",
      id: null,
      full_name: null,
      hasNextPage: false,
      end_cursor: null
    };
  }
};


export const getInstagramAccountDetail = (history, productId) => {
  return async dispatch => {
    try {
      dispatch({
        type: actionTypes.SET_LOADING,
        payload: true
      });
      const businessName = getBusinessNameFromUrl()

      const response = await axios.get(
        // `https://www.optimizeapp.com/optimize/public/webinfo/${businessName}`
        `${baseURL}webinfo/${businessName}`
        // `https://optimizekwtestingserver.com/optimize/public/webinfo/${businessName}`// OLD API

      );
      // console.log('resp', response)
      if (response && response.data) {
        const information = response.data;
        console.log("info", information);
        if (information.success) {
          // Return back if the list of exploreProducts is  >0 for now later switch the condition depending upon subscribe
          if (information.explore_products && information.explore_products.length > 0) {
            const accountInfo = {
              businessid: information.businessinfo.businessid,
              businessName,
              web_heading_key_name: information.businessinfo.web_heading_key_name,
              button_icon: information.businessinfo.button_icon,
              button_text: information.businessinfo.button_text,
              button_action: information.businessinfo.button_action,
              button_message: information.businessinfo.button_message,
              brandName: information.businessinfo.brandname,
              brandProfilePic: information.businessinfo.businesslogo,
              username: information.businessinfo.insta_handle,
              id: information.businessinfo.insta_handle,
              imagesList: [],
              end_cursor: null,
              hasNextPage: null,
              productDetail: {
                imageUrl: null,
                shortcode: null,
                imageId: null,
                thumbnail: null,
                caption: null,
                isVideo: null
              },
              whatsapp_campaign_enabled: information.businessinfo.whatsapp_campaign_enabled,
              instagram_campaign_enabled:
                information.businessinfo.instagram_campaign_enabled,
              snap_pixel_script: information.businessinfo.snap_pixel_script,
              whatsappLink: `https://api.whatsapp.com/send?phone=${information.businessinfo.whatsappnumber}`,
              whatsappnumber: information.businessinfo.whatsappnumber,
              telephoneNumber: information.businessinfo.callnumber,
              googlemaplink: information.businessinfo.googlemaplink,
              instagramLink: `https://www.instagram.com/${information.businessinfo.insta_handle}`,
              insta_handle: information.businessinfo.insta_handle,
              snapchat_handle: information.businessinfo.snapchat_handle,
              twitter_handle: information.businessinfo.twitter_handle,
              products_to_hide_id: null,
              products_to_hide_list: [],
              no_of_products_to_show: information.no_of_products_to_show,
              youtube_handle: information.businessinfo.youtube_handle,
              viewMore: information.businessinfo.viewMore,
              buttonInstagram: information.businessinfo.buttonInstagram,
              buttonWhatsapp: information.businessinfo.buttonWhatsapp,
              buttonPhone: information.businessinfo.buttonPhone,
              buttonSnapchat: information.businessinfo.buttonSnapchat,
              buttonTwitter: information.businessinfo.buttonTwitter,
              buttonMap: information.businessinfo.buttonMap,
              buttonYoutube: information.businessinfo.buttonYoutube,
              showIconButtonNames: information.businessinfo.showIconButtonNames === "1",
              popular_products: information.popular_products,
              featured_products: information.featured_products,
              explore_products: information.explore_products
            };
            dispatch({
              type: actionTypes.SET_INSTA_ACCOUNT_DETAILS,
              payload: accountInfo
            });

            return dispatch(myCartList())
          }


          // FOR INSTAGRAM TRAFFIC
          if (businessName === "alajmanalyoom") {
            const accountInfo = {
              businessid: information.businessinfo.businessid,
              businessName,
              brandName: information.businessinfo.brandname,
              brandProfilePic: information.businessinfo.businesslogo,
              web_heading_key_name: information.businessinfo.web_heading_key_name,
              button_icon: information.businessinfo.button_icon,
              button_text: information.businessinfo.button_text,
              button_action: information.businessinfo.button_action,
              button_message: information.businessinfo.button_message,
              username: null,
              id: null,
              imagesList: [],
              productDetail: {
                prices: [],
                imageUrl: null,
                shortcode: null,
                imageId: null,
                thumbnail: null,
                caption: null,
                isVideo: null
              },
              snap_pixel_script: information.businessinfo.snap_pixel_script,
              telephoneNumber: information.businessinfo.callnumber,
              whatsappLink: `https://api.whatsapp.com/send?phone=${information.businessinfo.whatsappnumber}`,
              whatsappnumber: information.businessinfo.whatsappnumber,
              instagramLink: `https://www.instagram.com/${information.businessinfo.insta_handle}`,
              insta_handle: information.businessinfo.insta_handle,
              googlemaplink: information.businessinfo.googlemaplink,
              instagram_campaign_enabled:
                information.businessinfo.instagram_campaign_enabled,
              snapchat_handle: information.businessinfo.snapchat_handle,
              twitter_handle: information.businessinfo.twitter_handle,
              no_of_products_to_show: information.no_of_products_to_show,
              youtube_handle: information.businessinfo.youtube_handle,
              viewMore: information.businessinfo.viewMore,
              buttonInstagram: information.businessinfo.buttonInstagram,
              buttonWhatsapp: information.businessinfo.buttonWhatsapp,
              buttonPhone: information.businessinfo.buttonPhone,
              buttonSnapchat: information.businessinfo.buttonSnapchat,
              buttonTwitter: information.businessinfo.buttonTwitter,
              buttonMap: information.businessinfo.buttonMap,
              buttonYoutube: information.businessinfo.buttonYoutube,
              showIconButtonNames: information.businessinfo.showIconButtonNames === "1",
              popular_products: information.popular_products,
              featured_products: information.featured_products
            };
            return dispatch({
              type: actionTypes.SET_INSTA_ACCOUNT_DETAILS,
              payload: accountInfo
            });
          } else
            if (
              information.businessinfo.instagram_campaign_enabled === "1" &&
              information.businessinfo.whatsapp_campaign_enabled === "0"
            ) {

              const data = await getInstagramImages(
                information.businessinfo.insta_handle
              );
              var imagesList = data && data.imagesList ? data.imagesList : []
              var end_cursor = data && data.end_cursor
              var hasNextPage = data && data.hasNextPage
              if (productId && data.imagesList) {
                var productDetail = find(
                  data.imagesList,
                  item => item.imageId === productId
                );
                if (!productDetail && data.hasNextPage) {
                  productDetail = await findInstagramPostById(data.id, data.end_cursor, productId)
                }
                productDetail[`media`] = []
              }
              var products_to_hide_id = null
              var webproducts = []
              // check which to hide from all list
              if (information.products_to_hide && information.products_to_hide.id) {
                products_to_hide_id = information.products_to_hide.id
                webproducts = JSON.parse(information.products_to_hide.webproducts);
                if (webproducts && webproducts.length > 0) {
                  // remove hidden products
                  imagesList = imagesList.filter((objFromImagesList) => {
                    return !webproducts.includes(objFromImagesList.imageId)
                  })
                }
              }
              // To Make the count as 12 always
              while ((imagesList.length % 12 !== 0 || imagesList.length === 0) && hasNextPage && end_cursor) {
                const newList = await loadInstagramPostBasedOnQuery(12 - (imagesList.length % 12), data.id, end_cursor, webproducts);
                end_cursor = newList.end_cursor
                hasNextPage = newList.hasNextPage
                imagesList = [...imagesList, ...newList.imagesList]
              }



              const accountInfo = {
                businessid: information.businessinfo.businessid,
                businessName,
                web_heading_key_name: information.businessinfo.web_heading_key_name,
                button_icon: information.businessinfo.button_icon,
                button_text: information.businessinfo.button_text,
                button_action: information.businessinfo.button_action,
                button_message: information.businessinfo.button_message,
                brandName: information.businessinfo.brandname,
                brandProfilePic: information.businessinfo.businesslogo,
                username: information.businessinfo.insta_handle,
                id: (data && data.id) || information.businessinfo.insta_handle,
                imagesList: imagesList.sort((a, b) => b.imageId - a.imageId),
                end_cursor,
                hasNextPage,
                productDetail: productDetail
                  ? productDetail
                  : {
                    imageUrl: null,
                    shortcode: null,
                    imageId: null,
                    thumbnail: null,
                    caption: null,
                    isVideo: null
                  },
                whatsapp_campaign_enabled: information.businessinfo.whatsapp_campaign_enabled,
                instagram_campaign_enabled:
                  information.businessinfo.instagram_campaign_enabled,
                snap_pixel_script: information.businessinfo.snap_pixel_script,
                whatsappLink: `https://api.whatsapp.com/send?phone=${information.businessinfo.whatsappnumber}`,
                whatsappnumber: information.businessinfo.whatsappnumber,
                telephoneNumber: information.businessinfo.callnumber,
                googlemaplink: information.businessinfo.googlemaplink,
                instagramLink: `https://www.instagram.com/${information.businessinfo.insta_handle}`,
                insta_handle: information.businessinfo.insta_handle,
                snapchat_handle: information.businessinfo.snapchat_handle,
                twitter_handle: information.businessinfo.twitter_handle,
                products_to_hide_id,
                products_to_hide_list: webproducts && webproducts.length > 0 ? webproducts : [],
                no_of_products_to_show: information.no_of_products_to_show,
                youtube_handle: information.businessinfo.youtube_handle,
                viewMore: information.businessinfo.viewMore,
                buttonInstagram: information.businessinfo.buttonInstagram,
                buttonWhatsapp: information.businessinfo.buttonWhatsapp,
                buttonPhone: information.businessinfo.buttonPhone,
                buttonSnapchat: information.businessinfo.buttonSnapchat,
                buttonTwitter: information.businessinfo.buttonTwitter,
                buttonMap: information.businessinfo.buttonMap,
                buttonYoutube: information.businessinfo.buttonYoutube,
                showIconButtonNames: information.businessinfo.showIconButtonNames === "1",
                popular_products: information.popular_products,
                featured_products: information.featured_products,
                explore_products: information.explore_products
              };
              return dispatch({
                type: actionTypes.SET_INSTA_ACCOUNT_DETAILS,
                payload: accountInfo
              });
            } // to check for whatsapp campaign
            else if (
              information.businessinfo.whatsapp_campaign_enabled === "1" &&
              information.businessinfo.instagram_campaign_enabled === "0"
            ) {
              // check if productList exist in dB products saved from APP
              if (information.productsinfo) {
                webproducts = JSON.parse(
                  information.productsinfo.webproducts
                );
                if (webproducts.length > 0) {
                  // console.log('web prod', webproducts);
                  if (productId) {
                    productDetail = find(
                      webproducts,
                      item => item.imageId === productId
                    );
                  }
                  const accountInfo = {
                    businessid: information.businessinfo.businessid,

                    businessName,
                    web_heading_key_name: information.businessinfo.web_heading_key_name,
                    button_icon: information.businessinfo.button_icon,
                    button_text: information.businessinfo.button_text,
                    button_action: information.businessinfo.button_action,
                    button_message: information.businessinfo.button_message,
                    brandName: information.businessinfo.brandname,
                    brandProfilePic: information.businessinfo.businesslogo,
                    username: information.businessinfo.insta_handle,
                    imagesList: webproducts,
                    // id: data.id,
                    // isPrivate: data.is_private,
                    // isVerified: data.is_verified,
                    // biography: data.biography,
                    // followedBy: data.edge_followed_by.count,
                    // following: data.edge_follow.count,
                    // imagesList,
                    productDetail: productDetail
                      ? productDetail
                      : {
                        imageUrl: null,
                        shortcode: null,
                        imageId: null,
                        thumbnail: null,
                        productDescription: null,
                        isVideo: null
                      },
                    snap_pixel_script: information.businessinfo.snap_pixel_script,
                    googlemaplink: information.businessinfo.googlemaplink,
                    telephoneNumber: information.businessinfo.callnumber,
                    whatsappnumber: information.businessinfo.whatsappnumber,
                    whatsappLink: `https://api.whatsapp.com/send?phone=${information.businessinfo.whatsappnumber}`,
                    instagramLink: `https://www.instagram.com/${information.businessinfo.insta_handle}`,
                    instagram_campaign_enabled:
                      information.businessinfo.instagram_campaign_enabled,
                    snapchat_handle: information.businessinfo.snapchat_handle,
                    twitter_handle: information.businessinfo.twitter_handle,
                    insta_handle: information.businessinfo.insta_handle,
                    no_of_products_to_show: information.no_of_products_to_show,
                    youtube_handle: information.businessinfo.youtube_handle,
                    viewMore: information.businessinfo.viewMore,
                    buttonInstagram: information.businessinfo.buttonInstagram,
                    buttonWhatsapp: information.businessinfo.buttonWhatsapp,
                    buttonPhone: information.businessinfo.buttonPhone,
                    buttonSnapchat: information.businessinfo.buttonSnapchat,
                    buttonTwitter: information.businessinfo.buttonTwitter,
                    buttonMap: information.businessinfo.buttonMap,
                    buttonYoutube: information.businessinfo.buttonYoutube,
                    showIconButtonNames: information.businessinfo.showIconButtonNames === "1"

                  };
                  // console.log('accountInfo productList exist', accountInfo);

                  return dispatch({
                    type: actionTypes.SET_INSTA_ACCOUNT_DETAILS,
                    payload: accountInfo
                  });
                }
              }

              if (information.businessinfo.insta_handle) {
                var data = await getInstagramImages(
                  information.businessinfo.insta_handle
                );
                imagesList = data && data.imagesList ? data.imagesList : []
                end_cursor = data && data.end_cursor
                hasNextPage = data && data.hasNextPage

                //Product Detail Screen
                if (productId && data.imagesList) {
                  productDetail = find(
                    data.imagesList,
                    item => item.imageId === productId
                  );
                  // to get product detail if its in a below list
                  if (!productDetail && data.hasNextPage) {
                    productDetail = await findInstagramPostById(data.id, data.end_cursor, productId)
                  }
                  productDetail[`media`] = []
                }
                // check which to hide from all list
                if (information.products_to_hide && information.products_to_hide.id) {
                  products_to_hide_id = information.products_to_hide.id
                  webproducts = JSON.parse(information.products_to_hide.webproducts);

                  if (webproducts && webproducts.length > 0) {
                    // remove hidden products
                    imagesList = imagesList.filter((objFromImagesList) => {
                      return !webproducts.includes(objFromImagesList.imageId)
                    })


                  }
                }

                // To Make the count as 12 always
                while ((imagesList.length % 12 !== 0 || imagesList.length === 0) && hasNextPage && end_cursor) {
                  const newList = await loadInstagramPostBasedOnQuery(12 - (imagesList.length % 12), data.id, end_cursor, webproducts);
                  end_cursor = newList.end_cursor
                  hasNextPage = newList.hasNextPage
                  imagesList = [...imagesList, ...newList.imagesList]
                  // console.log("imagesList len", imagesList.length);
                }



                var accountInfo = {
                  businessid: information.businessinfo.businessid,

                  businessName,
                  web_heading_key_name: information.businessinfo.web_heading_key_name,
                  button_icon: information.businessinfo.button_icon,
                  button_text: information.businessinfo.button_text,
                  button_action: information.businessinfo.button_action,
                  button_message: information.businessinfo.button_message,
                  brandName: information.businessinfo.brandname
                    ? information.businessinfo.brandname
                    : data.full_name,
                  brandProfilePic: information.businessinfo.businesslogo,
                  username: data.username,
                  id: data.id,
                  imagesList: imagesList.sort((a, b) => b.imageId - a.imageId),
                  productDetail: productDetail
                    ? productDetail
                    : {
                      imageUrl: null,
                      shortcode: null,
                      imageId: null,
                      thumbnail: null,
                      caption: null,
                      isVideo: null
                    },
                  snap_pixel_script: information.businessinfo.snap_pixel_script,
                  telephoneNumber: information.businessinfo.callnumber,
                  whatsappLink: `https://api.whatsapp.com/send?phone=${information.businessinfo.whatsappnumber}`,
                  whatsappnumber: information.businessinfo.whatsappnumber,
                  insta_handle: information.businessinfo.insta_handle,
                  instagramLink: `https://www.instagram.com/${information.businessinfo.insta_handle}`,
                  googlemaplink: information.businessinfo.googlemaplink,
                  instagram_campaign_enabled:
                    information.businessinfo.instagram_campaign_enabled,
                  snapchat_handle: information.businessinfo.snapchat_handle,
                  twitter_handle: information.businessinfo.twitter_handle,
                  end_cursor,
                  hasNextPage,
                  products_to_hide_id,
                  products_to_hide_list: webproducts && webproducts.length > 0 ? webproducts : [],
                  no_of_products_to_show: information.no_of_products_to_show,
                  youtube_handle: information.businessinfo.youtube_handle,
                  viewMore: information.businessinfo.viewMore,
                  buttonInstagram: information.businessinfo.buttonInstagram,
                  buttonWhatsapp: information.businessinfo.buttonWhatsapp,
                  buttonPhone: information.businessinfo.buttonPhone,
                  buttonSnapchat: information.businessinfo.buttonSnapchat,
                  buttonTwitter: information.businessinfo.buttonTwitter,
                  buttonMap: information.businessinfo.buttonMap,
                  buttonYoutube: information.businessinfo.buttonYoutube,
                  showIconButtonNames: information.businessinfo.showIconButtonNames === "1",
                  popular_products: information.popular_products,
                  featured_products: information.featured_products,
                  explore_products: information.explore_products
                };
              } else {

                accountInfo = {
                  businessid: information.businessinfo.businessid,

                  businessName,
                  web_heading_key_name: information.businessinfo.web_heading_key_name,
                  button_icon: information.businessinfo.button_icon,
                  button_text: information.businessinfo.button_text,
                  button_action: information.businessinfo.button_action,
                  button_message: information.businessinfo.button_message,
                  brandName: information.businessinfo.brandname,
                  brandProfilePic: information.businessinfo.businesslogo,
                  username: data && data.username,
                  end_cursor,
                  hasNextPage,

                  id: data && data.id,
                  imagesList: imagesList.sort((a, b) => b.imageId - a.imageId),
                  productDetail: productDetail
                    ? productDetail
                    : {
                      imageUrl: null,
                      shortcode: null,
                      imageId: null,
                      thumbnail: null,
                      caption: null,
                      isVideo: null
                    },
                  snap_pixel_script: information.businessinfo.snap_pixel_script,
                  telephoneNumber: information.businessinfo.callnumber,
                  whatsappLink: `https://api.whatsapp.com/send?phone=${information.businessinfo.whatsappnumber}`,
                  whatsappnumber: information.businessinfo.whatsappnumber,
                  instagramLink: `https://www.instagram.com/${information.businessinfo.insta_handle}`,
                  insta_handle: information.businessinfo.insta_handle,
                  googlemaplink: information.businessinfo.googlemaplink,
                  instagram_campaign_enabled:
                    information.businessinfo.instagram_campaign_enabled,
                  snapchat_handle: information.businessinfo.snapchat_handle,
                  twitter_handle: information.businessinfo.twitter_handle,
                  products_to_hide_id,
                  products_to_hide_list: webproducts && webproducts.length > 0 ? webproducts : [],
                  no_of_products_to_show: information.no_of_products_to_show,
                  youtube_handle: information.businessinfo.youtube_handle,
                  viewMore: information.businessinfo.viewMore,
                  buttonInstagram: information.businessinfo.buttonInstagram,
                  buttonWhatsapp: information.businessinfo.buttonWhatsapp,
                  buttonPhone: information.businessinfo.buttonPhone,
                  buttonSnapchat: information.businessinfo.buttonSnapchat,
                  buttonTwitter: information.businessinfo.buttonTwitter,
                  buttonMap: information.businessinfo.buttonMap,
                  buttonYoutube: information.businessinfo.buttonYoutube,
                  showIconButtonNames: information.businessinfo.showIconButtonNames === "1",
                  popular_products: information.popular_products,
                  featured_products: information.featured_products,
                  explore_products: information.explore_products
                };
              }
              // console.log('accountInfo', accountInfo);
              return dispatch({
                type: actionTypes.SET_INSTA_ACCOUNT_DETAILS,
                payload: accountInfo
              });
              // by default for all other campaigns get from instagram
            }
        } else {
          history.push({ pathname: "/404" });

          return dispatch({
            type: actionTypes.ERROR_INSTA_ACCOUNT_DETAILS,
            payload: information
          });
        }
      }

      // };
    } catch (error) {
      console.log(
        "error insta account",
        error.response || error.message || "Oops! Something went wrong."
      );

      return dispatch({
        type: actionTypes.ERROR_INSTA_ACCOUNT_DETAILS,
        payload: {
          success: false,
          message:
            error.message || error.response || "Oops! Something went wrong."
        }
      });
    }
  };
};

const checkImageExist = (stateImagesArray, imageId) => {
  return !stateImagesArray.includes(imageId)
}
// For HomePage loading more instagram post
export const loadMoreInstagramPost = (instaHandleId, instaEndCursor) => {
  return async (dispatch, getState) => {
    try {
      // dispatch({
      //   type: actionTypes.LOADING_MORE_INSTAGRAM_POST,
      //   payload: true
      // });
      const responseMedia = await axios.get(
        `https://www.instagram.com/graphql/query/?query_id=17888483320059182&variables={"id":"${instaHandleId}","first":12,"after":"${instaEndCursor}"}`
      );
      // console.log("responseMediA", responseMedia.data);

      let mediaArray = [
        ...responseMedia.data.data.user.edge_owner_to_timeline_media.edges
      ];

      var hasNextPage =
        responseMedia.data.data.user.edge_owner_to_timeline_media.page_info
          .has_next_page;
      var end_cursor =
        responseMedia.data.data.user.edge_owner_to_timeline_media.page_info
          .end_cursor;

      if (mediaArray && mediaArray.length > 0) {
        var imagesList = mediaArray.map(media => {
          return {
            imageUrl: media.node.display_url,
            shortcode: media.node.shortcode,
            imageId: media.node.id,
            productDescription:
              media.node.edge_media_to_caption.edges.length > 0
                ? media.node.edge_media_to_caption.edges[0].node.text
                : "",
            isVideo: media.node.is_video
          };
        });

        // imagesList = imagesList.filter(item => {
        //   return !item.isVideo;
        // });
        // check which to hide from all list
        const products_to_hide_list = getState().campaign.instagramAccountInfo.products_to_hide_list;
        if (products_to_hide_list && products_to_hide_list.length > 0) {
          // remove hidden products
          imagesList = imagesList.filter((objFromImagesList) => {
            return !products_to_hide_list.includes(objFromImagesList.imageId)
          })

        }

        // To Make the count as 12 always
        while ((imagesList.length % 12 !== 0 || imagesList.length === 0) && hasNextPage && end_cursor) {
          const newList = await loadInstagramPostBasedOnQuery(12 - (imagesList.length % 12), instaHandleId, end_cursor, products_to_hide_list);
          end_cursor = newList.end_cursor
          hasNextPage = newList.hasNextPage
          var stateImagesList = getState().campaign.instagramAccountInfo.imagesList

          imagesList = [...imagesList, ...newList.imagesList]
          //to remove repeat from previous array
          if (stateImagesList && stateImagesList.length > 0) {
            stateImagesList = stateImagesList.map(stateImage => stateImage.imageId)

            // eslint-disable-next-line no-loop-func
            imagesList = imagesList.filter(image => { return checkImageExist(stateImagesList, image.imageId) })
          }
        }
        return dispatch({
          type: actionTypes.GET_MORE_INSTAGRAM_POST,
          payload: {
            imagesList,
            hasNextPage,
            end_cursor
          }
        });
      }
    } catch (error) {
      // console.log("ERROR LOADING MORE", error.message || error.response);

      return dispatch({
        type: actionTypes.ERROR_GET_MORE_INSTAGRAM_POST,
        payload: {
          imagesList: [],
          instaHasNextPage: null,
          hasNextPage: null
        }
      });
    }
    // console.log('imageListAfterSize', imagesList.length);
  };
};

//For searching product detail from post that have productId down in the list
export const findInstagramPostById = async (instaHandleId, instaEndCursor, productId) => {

  try {

    const responseMedia = await axios.get(
      `https://www.instagram.com/graphql/query/?query_id=17888483320059182&variables={"id":"${instaHandleId}","first":12,"after":"${instaEndCursor}"}`
    );
    // console.log("responseMediA", responseMedia.data);

    let mediaArray = [
      ...responseMedia.data.data.user.edge_owner_to_timeline_media.edges
    ];

    // let hasNextPage =
    //   responseMedia.data.data.user.edge_owner_to_timeline_media.page_info
    //     .has_next_page;
    let end_cursor =
      responseMedia.data.data.user.edge_owner_to_timeline_media.page_info
        .end_cursor;

    if (mediaArray && mediaArray.length > 0) {
      var imagesList = mediaArray.map(media => {
        return {
          imageUrl: media.node.display_url,
          shortcode: media.node.shortcode,
          imageId: media.node.id,
          productDescription:
            media.node.edge_media_to_caption.edges.length > 0
              ? media.node.edge_media_to_caption.edges[0].node.text
              : "",
          isVideo: media.node.is_video
        };
      });

      // imagesList = imagesList.filter(item => {
      //   return !item.isVideo;
      // });
      const productDetail = imagesList.find(product => product.imageId === productId)
      if (productDetail) {
        return productDetail
      }
      // recurssive call to find images from list
      else return await findInstagramPostById(instaHandleId, end_cursor, productId)

    }
  } catch (error) {
    // console.log("ERROR LOADING MORE", error.message || error.response);

    return { productDetail: null }

  }
  // console.log('imageListAfterSize', imagesList.length);

};


// For HomePage loading more instagram post based on query
export const loadInstagramPostBasedOnQuery = async (loadMoreImageNo, instaHandleId, instaEndCursor, products_to_hide) => {
  try {
    const responseMedia = await axios.get(
      `https://www.instagram.com/graphql/query/?query_id=17888483320059182&variables={"id":"${instaHandleId}","first":${loadMoreImageNo},"after":"${instaEndCursor}"}`
    );
    // console.log("responseMediA", responseMedia.data);

    let mediaArray = [
      ...responseMedia.data.data.user.edge_owner_to_timeline_media.edges
    ];

    let hasNextPage =
      responseMedia.data.data.user.edge_owner_to_timeline_media.page_info
        .has_next_page;
    let end_cursor =
      responseMedia.data.data.user.edge_owner_to_timeline_media.page_info
        .end_cursor;

    if (mediaArray && mediaArray.length > 0) {
      var imagesList = mediaArray.map(media => {
        return {
          imageUrl: media.node.display_url,
          shortcode: media.node.shortcode,
          imageId: media.node.id,
          productDescription:
            media.node.edge_media_to_caption.edges.length > 0
              ? media.node.edge_media_to_caption.edges[0].node.text
              : "",
          isVideo: media.node.is_video
        };
      });

      // imagesList = imagesList.filter(item => {
      //   return !item.isVideo;
      // });
      // check if hide list included
      if (products_to_hide && products_to_hide.length > 0) {
        imagesList = imagesList.filter((objFromImagesList) => {
          return !products_to_hide.includes(objFromImagesList.imageId)
        })
      }

      // if (imagesList.length === loadMoreImageNo || !hasNextPage || !end_cursor) {
      return {
        imagesList,
        hasNextPage,
        end_cursor
      }
      // }
      // return await loadInstagramPostBasedOnQuery((loadMoreImageNo - imagesList.length), instaHandleId, end_cursor, products_to_hide);

    }
  } catch (error) {
    // console.log("ERROR LOADING MORE based on query", error.message || error.response);

    return {
      imagesList: [],
      hasNextPage: null,
      end_cursor: null
    }

  }
};

export const updateBusinessLogo = (businessid, insta_handle) => {
  return async dispatch => {
    try {
      const response = await axios.get(`https://www.instagram.com/${insta_handle}/?__a=1`)
      if (response.data && response.data.graphql && response.data.graphql.user) {
        const businesslogo = response.data.graphql.user.profile_pic_url
        axios.post(`${baseURL}businesslogo`, {
          businessid,
          businesslogo
        }).then(resp => {
          console.log('resp', resp.data);
          return resp.data
        }).catch(error => {
          console.log('error saving', error.response || error.message);
        })
        return dispatch({
          type: actionTypes.UPDATE_ACCOUNT_INFO,
          payload: {
            brandProfilePic: businesslogo
          }
        })
      }

    } catch (error) {
      // console.log('error', error.response || error.message);

    }
  }
}

export const searchForProductOnBackEnd = (productId, history, currency) => {
  return dispatch => {
    axios.post(`https://www.optimizeapp.com/webapi/public/productdetail`, {
      product_id: productId,
      currency
    }).then(res => {
      return res.data
    }).then(async data1 => {
      console.log('productDetail', data1);

      let productDetail = {
        imageUrl: null,
        shortcode: null,
        imageId: null,
        thumbnail: null,
        caption: null,
        isVideo: null,
        id: null
      }
      if (data1.success) {
        const productinfo = data1.productinfo;

        productDetail = {
          imageUrl: productinfo.media[0].url,
          shortcode: productinfo.media[0].shortcode,
          productDescription: productinfo.description_en || productinfo.description_ar,
          productName: productinfo.name,
          prices: productinfo.prices.length > 0 ? productinfo.prices : [],
          media: productinfo.media,
          button_action: productinfo.button_action,
          button_message: productinfo.button_message,
          button_message_ar: productinfo.button_message_ar,
          whatsappLink: `https://api.whatsapp.com/send?phone=${productinfo.whatsappnumber}`,
          whatsappnumber: productinfo.whatsappnumber,
          id: productinfo.id
        }

        return dispatch({
          type: actionTypes.SET_PRODUCT_DETAIL,
          payload: productDetail
        })

      } else {
        try {
          dispatch({
            type: actionTypes.SET_LOADING,
            payload: true
          });
          const businessName = getBusinessNameFromUrl()

          const response = await axios.get(
            // `https://www.optimizeapp.com/optimize/public/webinfo/${businessName}`
            `${baseURL}webinfo/${businessName}`
            // `https://optimizekwtestingserver.com/optimize/public/webinfo/${businessName}`// OLD API

          );
          // console.log('resp', response)
          if (response && response.data) {
            const information = response.data;
            console.log("info", information);
            if (information.success) {

              // FOR INSTAGRAM TRAFFIC
              if (businessName === "alajmanalyoom") {
                const accountInfo = {
                  businessid: information.businessinfo.businessid,
                  businessName,
                  brandName: information.businessinfo.brandname,
                  brandProfilePic: information.businessinfo.businesslogo,
                  web_heading_key_name: information.businessinfo.web_heading_key_name,
                  button_icon: information.businessinfo.button_icon,
                  button_text: information.businessinfo.button_text,
                  button_action: information.businessinfo.button_action,
                  button_message: information.businessinfo.button_message,
                  username: null,
                  id: null,
                  imagesList: [],
                  productDetail: {
                    prices: [],
                    imageUrl: null,
                    shortcode: null,
                    imageId: null,
                    thumbnail: null,
                    caption: null,
                    isVideo: null
                  },
                  snap_pixel_script: information.businessinfo.snap_pixel_script,
                  telephoneNumber: information.businessinfo.callnumber,
                  whatsappLink: `https://api.whatsapp.com/send?phone=${information.businessinfo.whatsappnumber}`,
                  whatsappnumber: information.businessinfo.whatsappnumber,
                  instagramLink: `https://www.instagram.com/${information.businessinfo.insta_handle}`,
                  insta_handle: information.businessinfo.insta_handle,
                  googlemaplink: information.businessinfo.googlemaplink,
                  instagram_campaign_enabled:
                    information.businessinfo.instagram_campaign_enabled,
                  snapchat_handle: information.businessinfo.snapchat_handle,
                  twitter_handle: information.businessinfo.twitter_handle,
                  no_of_products_to_show: information.no_of_products_to_show,
                  youtube_handle: information.businessinfo.youtube_handle,
                  viewMore: information.businessinfo.viewMore,
                  buttonInstagram: information.businessinfo.buttonInstagram,
                  buttonWhatsapp: information.businessinfo.buttonWhatsapp,
                  buttonPhone: information.businessinfo.buttonPhone,
                  buttonSnapchat: information.businessinfo.buttonSnapchat,
                  buttonTwitter: information.businessinfo.buttonTwitter,
                  buttonMap: information.businessinfo.buttonMap,
                  buttonYoutube: information.businessinfo.buttonYoutube,
                  showIconButtonNames: information.businessinfo.showIconButtonNames === "1",
                  popular_products: information.popular_products,
                  featured_products: information.featured_products,
                  explore_products: information.explore_products
                };
                return dispatch({
                  type: actionTypes.SET_INSTA_ACCOUNT_DETAILS,
                  payload: accountInfo
                });
              } else
                if (
                  information.businessinfo.instagram_campaign_enabled === "1" &&
                  information.businessinfo.whatsapp_campaign_enabled === "0"
                ) {

                  const data = await getInstagramImages(
                    information.businessinfo.insta_handle
                  );
                  var imagesList = data && data.imagesList ? data.imagesList : []
                  var end_cursor = data && data.end_cursor
                  var hasNextPage = data && data.hasNextPage
                  if (productId && data.imagesList) {
                    productDetail = find(
                      data.imagesList,
                      item => item.imageId === productId
                    );
                    if (!productDetail && data.hasNextPage) {
                      productDetail = await findInstagramPostById(data.id, data.end_cursor, productId)
                    }
                    productDetail[`media`] = []
                  }
                  var products_to_hide_id = null
                  var webproducts = []
                  // check which to hide from all list
                  if (information.products_to_hide && information.products_to_hide.id) {
                    products_to_hide_id = information.products_to_hide.id
                    webproducts = JSON.parse(information.products_to_hide.webproducts);
                    if (webproducts && webproducts.length > 0) {
                      // remove hidden products
                      imagesList = imagesList.filter((objFromImagesList) => {
                        return !webproducts.includes(objFromImagesList.imageId)
                      })
                    }
                  }
                  // To Make the count as 12 always
                  while ((imagesList.length % 12 !== 0 || imagesList.length === 0) && hasNextPage && end_cursor) {
                    const newList = await loadInstagramPostBasedOnQuery(12 - (imagesList.length % 12), data.id, end_cursor, webproducts);
                    end_cursor = newList.end_cursor
                    hasNextPage = newList.hasNextPage
                    imagesList = [...imagesList, ...newList.imagesList]
                  }



                  const accountInfo = {
                    businessid: information.businessinfo.businessid,
                    businessName,
                    web_heading_key_name: information.businessinfo.web_heading_key_name,
                    button_icon: information.businessinfo.button_icon,
                    button_text: information.businessinfo.button_text,
                    button_action: information.businessinfo.button_action,
                    button_message: information.businessinfo.button_message,
                    brandName: information.businessinfo.brandname,
                    brandProfilePic: information.businessinfo.businesslogo,
                    username: information.businessinfo.insta_handle,
                    id: (data && data.id) || information.businessinfo.insta_handle,
                    imagesList: imagesList.sort((a, b) => b.imageId - a.imageId),
                    end_cursor,
                    hasNextPage,
                    productDetail: productDetail
                      ? productDetail
                      : {
                        imageUrl: null,
                        shortcode: null,
                        imageId: null,
                        thumbnail: null,
                        caption: null,
                        isVideo: null
                      },
                    whatsapp_campaign_enabled: information.businessinfo.whatsapp_campaign_enabled,
                    instagram_campaign_enabled:
                      information.businessinfo.instagram_campaign_enabled,
                    snap_pixel_script: information.businessinfo.snap_pixel_script,
                    whatsappLink: `https://api.whatsapp.com/send?phone=${information.businessinfo.whatsappnumber}`,
                    whatsappnumber: information.businessinfo.whatsappnumber,
                    telephoneNumber: information.businessinfo.callnumber,
                    googlemaplink: information.businessinfo.googlemaplink,
                    instagramLink: `https://www.instagram.com/${information.businessinfo.insta_handle}`,
                    insta_handle: information.businessinfo.insta_handle,
                    snapchat_handle: information.businessinfo.snapchat_handle,
                    twitter_handle: information.businessinfo.twitter_handle,
                    products_to_hide_id,
                    products_to_hide_list: webproducts && webproducts.length > 0 ? webproducts : [],
                    no_of_products_to_show: information.no_of_products_to_show,
                    youtube_handle: information.businessinfo.youtube_handle,
                    viewMore: information.businessinfo.viewMore,
                    buttonInstagram: information.businessinfo.buttonInstagram,
                    buttonWhatsapp: information.businessinfo.buttonWhatsapp,
                    buttonPhone: information.businessinfo.buttonPhone,
                    buttonSnapchat: information.businessinfo.buttonSnapchat,
                    buttonTwitter: information.businessinfo.buttonTwitter,
                    buttonMap: information.businessinfo.buttonMap,
                    buttonYoutube: information.businessinfo.buttonYoutube,
                    showIconButtonNames: information.businessinfo.showIconButtonNames === "1",
                    popular_products: information.popular_products,
                    explore_products: information.explore_products,
                    featured_products: information.featured_products,
                  };
                  return dispatch({
                    type: actionTypes.SET_INSTA_ACCOUNT_DETAILS,
                    payload: accountInfo
                  });
                } // to check for whatsapp campaign
                else if (
                  information.businessinfo.whatsapp_campaign_enabled === "1" &&
                  information.businessinfo.instagram_campaign_enabled === "0"
                ) {
                  // check if productList exist in dB products saved from APP
                  if (information.productsinfo) {
                    webproducts = JSON.parse(
                      information.productsinfo.webproducts
                    );
                    if (webproducts.length > 0) {
                      // console.log('web prod', webproducts);
                      if (productId) {
                        productDetail = find(
                          webproducts,
                          item => item.imageId === productId
                        );
                      }
                      const accountInfo = {
                        businessid: information.businessinfo.businessid,

                        businessName,
                        web_heading_key_name: information.businessinfo.web_heading_key_name,
                        button_icon: information.businessinfo.button_icon,
                        button_text: information.businessinfo.button_text,
                        button_action: information.businessinfo.button_action,
                        button_message: information.businessinfo.button_message,
                        brandName: information.businessinfo.brandname,
                        brandProfilePic: information.businessinfo.businesslogo,
                        username: information.businessinfo.insta_handle,
                        imagesList: webproducts,
                        // id: data.id,
                        // isPrivate: data.is_private,
                        // isVerified: data.is_verified,
                        // biography: data.biography,
                        // followedBy: data.edge_followed_by.count,
                        // following: data.edge_follow.count,
                        // imagesList,
                        productDetail: productDetail
                          ? productDetail
                          : {
                            imageUrl: null,
                            shortcode: null,
                            imageId: null,
                            thumbnail: null,
                            productDescription: null,
                            isVideo: null
                          },
                        snap_pixel_script: information.businessinfo.snap_pixel_script,
                        googlemaplink: information.businessinfo.googlemaplink,
                        telephoneNumber: information.businessinfo.callnumber,
                        whatsappnumber: information.businessinfo.whatsappnumber,
                        whatsappLink: `https://api.whatsapp.com/send?phone=${information.businessinfo.whatsappnumber}`,
                        instagramLink: `https://www.instagram.com/${information.businessinfo.insta_handle}`,
                        instagram_campaign_enabled:
                          information.businessinfo.instagram_campaign_enabled,
                        snapchat_handle: information.businessinfo.snapchat_handle,
                        twitter_handle: information.businessinfo.twitter_handle,
                        insta_handle: information.businessinfo.insta_handle,
                        no_of_products_to_show: information.no_of_products_to_show,
                        youtube_handle: information.businessinfo.youtube_handle,
                        viewMore: information.businessinfo.viewMore,
                        buttonInstagram: information.businessinfo.buttonInstagram,
                        buttonWhatsapp: information.businessinfo.buttonWhatsapp,
                        buttonPhone: information.businessinfo.buttonPhone,
                        buttonSnapchat: information.businessinfo.buttonSnapchat,
                        buttonTwitter: information.businessinfo.buttonTwitter,
                        buttonMap: information.businessinfo.buttonMap,
                        buttonYoutube: information.businessinfo.buttonYoutube,
                        showIconButtonNames: information.businessinfo.showIconButtonNames === "1",
                        explore_products: information.explore_products

                      };
                      // console.log('accountInfo productList exist', accountInfo);

                      return dispatch({
                        type: actionTypes.SET_INSTA_ACCOUNT_DETAILS,
                        payload: accountInfo
                      });
                    }
                  }

                  if (information.businessinfo.insta_handle) {
                    var data = await getInstagramImages(
                      information.businessinfo.insta_handle
                    );
                    imagesList = data && data.imagesList ? data.imagesList : []
                    end_cursor = data && data.end_cursor
                    hasNextPage = data && data.hasNextPage

                    //Product Detail Screen
                    if (productId && data.imagesList) {
                      productDetail = find(
                        data.imagesList,
                        item => item.imageId === productId
                      );
                      // to get product detail if its in a below list
                      if (!productDetail && data.hasNextPage) {
                        productDetail = await findInstagramPostById(data.id, data.end_cursor, productId)
                      }
                      productDetail[`media`] = []
                    }
                    // check which to hide from all list
                    if (information.products_to_hide && information.products_to_hide.id) {
                      products_to_hide_id = information.products_to_hide.id
                      webproducts = JSON.parse(information.products_to_hide.webproducts);

                      if (webproducts && webproducts.length > 0) {
                        // remove hidden products
                        imagesList = imagesList.filter((objFromImagesList) => {
                          return !webproducts.includes(objFromImagesList.imageId)
                        })


                      }
                    }

                    // To Make the count as 12 always
                    while ((imagesList.length % 12 !== 0 || imagesList.length === 0) && hasNextPage && end_cursor) {
                      const newList = await loadInstagramPostBasedOnQuery(12 - (imagesList.length % 12), data.id, end_cursor, webproducts);
                      end_cursor = newList.end_cursor
                      hasNextPage = newList.hasNextPage
                      imagesList = [...imagesList, ...newList.imagesList]
                      // console.log("imagesList len", imagesList.length);
                    }



                    var accountInfo = {
                      businessid: information.businessinfo.businessid,

                      businessName,
                      web_heading_key_name: information.businessinfo.web_heading_key_name,
                      button_icon: information.businessinfo.button_icon,
                      button_text: information.businessinfo.button_text,
                      button_action: information.businessinfo.button_action,
                      button_message: information.businessinfo.button_message,
                      brandName: information.businessinfo.brandname
                        ? information.businessinfo.brandname
                        : data.full_name,
                      brandProfilePic: information.businessinfo.businesslogo,
                      username: data.username,
                      id: data.id,
                      imagesList: imagesList.sort((a, b) => b.imageId - a.imageId),
                      productDetail: productDetail
                        ? productDetail
                        : {
                          imageUrl: null,
                          shortcode: null,
                          imageId: null,
                          thumbnail: null,
                          caption: null,
                          isVideo: null
                        },
                      snap_pixel_script: information.businessinfo.snap_pixel_script,
                      telephoneNumber: information.businessinfo.callnumber,
                      whatsappLink: `https://api.whatsapp.com/send?phone=${information.businessinfo.whatsappnumber}`,
                      whatsappnumber: information.businessinfo.whatsappnumber,
                      insta_handle: information.businessinfo.insta_handle,
                      instagramLink: `https://www.instagram.com/${information.businessinfo.insta_handle}`,
                      googlemaplink: information.businessinfo.googlemaplink,
                      instagram_campaign_enabled:
                        information.businessinfo.instagram_campaign_enabled,
                      snapchat_handle: information.businessinfo.snapchat_handle,
                      twitter_handle: information.businessinfo.twitter_handle,
                      end_cursor,
                      hasNextPage,
                      products_to_hide_id,
                      products_to_hide_list: webproducts && webproducts.length > 0 ? webproducts : [],
                      no_of_products_to_show: information.no_of_products_to_show,
                      youtube_handle: information.businessinfo.youtube_handle,
                      viewMore: information.businessinfo.viewMore,
                      buttonInstagram: information.businessinfo.buttonInstagram,
                      buttonWhatsapp: information.businessinfo.buttonWhatsapp,
                      buttonPhone: information.businessinfo.buttonPhone,
                      buttonSnapchat: information.businessinfo.buttonSnapchat,
                      buttonTwitter: information.businessinfo.buttonTwitter,
                      buttonMap: information.businessinfo.buttonMap,
                      buttonYoutube: information.businessinfo.buttonYoutube,
                      showIconButtonNames: information.businessinfo.showIconButtonNames === "1",
                      popular_products: information.popular_products,
                      featured_products: information.featured_products,
                      explore_products: information.explore_products

                    };
                  } else {

                    accountInfo = {
                      businessid: information.businessinfo.businessid,
                      businessName,
                      web_heading_key_name: information.businessinfo.web_heading_key_name,
                      button_icon: information.businessinfo.button_icon,
                      button_text: information.businessinfo.button_text,
                      button_action: information.businessinfo.button_action,
                      button_message: information.businessinfo.button_message,
                      brandName: information.businessinfo.brandname,
                      brandProfilePic: information.businessinfo.businesslogo,
                      username: data && data.username,
                      end_cursor,
                      hasNextPage,

                      id: data && data.id,
                      imagesList: imagesList.sort((a, b) => b.imageId - a.imageId),
                      productDetail: productDetail
                        ? productDetail
                        : {
                          imageUrl: null,
                          shortcode: null,
                          imageId: null,
                          thumbnail: null,
                          caption: null,
                          isVideo: null
                        },
                      snap_pixel_script: information.businessinfo.snap_pixel_script,
                      telephoneNumber: information.businessinfo.callnumber,
                      whatsappLink: `https://api.whatsapp.com/send?phone=${information.businessinfo.whatsappnumber}`,
                      whatsappnumber: information.businessinfo.whatsappnumber,
                      instagramLink: `https://www.instagram.com/${information.businessinfo.insta_handle}`,
                      insta_handle: information.businessinfo.insta_handle,
                      googlemaplink: information.businessinfo.googlemaplink,
                      instagram_campaign_enabled:
                        information.businessinfo.instagram_campaign_enabled,
                      snapchat_handle: information.businessinfo.snapchat_handle,
                      twitter_handle: information.businessinfo.twitter_handle,
                      products_to_hide_id,
                      products_to_hide_list: webproducts && webproducts.length > 0 ? webproducts : [],
                      no_of_products_to_show: information.no_of_products_to_show,
                      youtube_handle: information.businessinfo.youtube_handle,
                      viewMore: information.businessinfo.viewMore,
                      buttonInstagram: information.businessinfo.buttonInstagram,
                      buttonWhatsapp: information.businessinfo.buttonWhatsapp,
                      buttonPhone: information.businessinfo.buttonPhone,
                      buttonSnapchat: information.businessinfo.buttonSnapchat,
                      buttonTwitter: information.businessinfo.buttonTwitter,
                      buttonMap: information.businessinfo.buttonMap,
                      buttonYoutube: information.businessinfo.buttonYoutube,
                      showIconButtonNames: information.businessinfo.showIconButtonNames === "1",
                      popular_products: information.popular_products,
                      featured_products: information.featured_products,
                      explore_products: information.explore_products
                    };
                  }
                  // console.log('accountInfo', accountInfo);
                  return dispatch({
                    type: actionTypes.SET_INSTA_ACCOUNT_DETAILS,
                    payload: accountInfo
                  });
                  // by default for all other campaigns get from instagram
                }
            } else {
              history.push({ pathname: "/404" });

              return dispatch({
                type: actionTypes.ERROR_INSTA_ACCOUNT_DETAILS,
                payload: information
              });
            }
          }

          // };
        } catch (error) {
          console.log(
            "error insta account",
            error.response || error.message || "Oops! Something went wrong."
          );

          return dispatch({
            type: actionTypes.ERROR_INSTA_ACCOUNT_DETAILS,
            payload: {
              success: false,
              message:
                error.message || error.response || "Oops! Something went wrong."
            }
          });
        }

      }
    }).catch(err => {
      console.log('errr', err.response || err.message);
    })
  }
}



export const filterProductsByName = (query) => {
  return (dispatch, getState) => {
    if(query === "") {
      dispatch(getInstagramAccountDetail())
    }
    if(query !== ""){
      let popularProductsList =[...getState().campaign.popularProductsList];
      let featuredProductsList = [...getState().campaign.featuredProductsList];
      let explore_products = [...getState().campaign.explore_products]

      popularProductsList = popularProductsList.filter(prod => prod.name.toLowerCase().includes(query.toLowerCase()))
      featuredProductsList = featuredProductsList.filter(prod => prod.name.toLowerCase().includes(query.toLowerCase()))
      explore_products = explore_products.filter(prod => prod.name.toLowerCase().includes(query.toLowerCase()))


        return dispatch({
          type: actionTypes.SET_FILTER_PRODUCTS, 
          payload: {
            popularProductsList,
            featuredProductsList,
            explore_products
          }
        })
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/actions/campaign.action.js